import {useState} from 'react'
import {getMinWidth, getMaxWidth} from '../utils/chatUtils'

export const useChatState = (position) => {
  const [minWidth, setMinWidth] = useState(getMinWidth)
  const [maxWidth, setMaxWidth] = useState(getMaxWidth)
  const [showFullScreen, setShowFullScreen] = useState(false)
  const [showDragbar, setShowDragbar] = useState(false)
  const [containerWidth, setContainerWidth] = useState(position)
  const [showInfoBanner, setShowInfoBanner] = useState(false)
  const [hiddenWarningBanners, setHiddenWarningBanners] = useState([])

  const [messages, setMessages] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [disableSendButton, setDisableSendButton] = useState(true)
  const [isRequestActive, setIsRequestActive] = useState(false)
  const [activeRequestId, setActiveRequestId] = useState(null)

  const [userId, setUserId] = useState(null)
  const [sessionId, setSessionId] = useState(null)
  const [isInitialized, setIsInitialized] = useState(false)

  const [chartDownloadMenuAnchor, setChartDownloadMenuAnchor] = useState(null)
  const [selectedChartMessageId, setSelectedChartMessageId] = useState(null)
  const [downloadMenuAnchor, setDownloadMenuAnchor] = useState(null)
  const [selectedDownloadMessageId, setSelectedDownloadMessageId] = useState(null)
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)
  const [expandShrinkTooltipOpen, setExpandShrinkTooltipOpen] = useState(false)

  const [showCopyToClipboard, setShowCopyToClipboard] = useState(false)

  return {
    uiState: {
      minWidth,
      setMinWidth,
      maxWidth,
      setMaxWidth,
      showFullScreen,
      setShowFullScreen,
      showDragbar,
      setShowDragbar,
      containerWidth,
      setContainerWidth,
      showInfoBanner,
      setShowInfoBanner,
      hiddenWarningBanners,
      setHiddenWarningBanners
    },

    chatState: {
      messages,
      setMessages,
      showLoader,
      setShowLoader,
      disableSendButton,
      setDisableSendButton,
      isRequestActive,
      setIsRequestActive,
      activeRequestId,
      setActiveRequestId
    },

    sessionState: {
      userId,
      setUserId,
      sessionId,
      setSessionId,
      isInitialized,
      setIsInitialized
    },

    menuState: {
      chartDownloadMenuAnchor,
      setChartDownloadMenuAnchor,
      selectedChartMessageId,
      setSelectedChartMessageId,
      downloadMenuAnchor,
      setDownloadMenuAnchor,
      selectedDownloadMessageId,
      setSelectedDownloadMessageId,
      showConfirmationDialog,
      setShowConfirmationDialog,
      expandShrinkTooltipOpen,
      setExpandShrinkTooltipOpen
    },

    notificationState: {
      showCopyToClipboard,
      setShowCopyToClipboard
    }
  }
}

/*
CHATBOT STATE MANAGEMENT HOOK

KEY FUNCTIONS:
- Consolidates all chatbot state into organized categories
- Provides structured state management with grouped return object
- Manages UI layout, chat messages, session data, feedback, menus, and notifications

STATE CATEGORIES:
- uiState: Layout dimensions, fullscreen, dragbar, banners, tooltips
- chatState: Messages array, loading states, request handling, send button control
- sessionState: User ID, session ID, initialization status
- menuState: Download menus, confirmation dialogs, chart interactions
- notificationState: Clipboard notifications and other alerts
*/
